import { useState, useCallback, createElement as rc } from 'react';
import { Icon, View, fromTheme, webOnlyStyles, styled } from 'lib_ui-primitives';

const ToggleGroup = styled(View)`
    flex-direction: row;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    gap: ${fromTheme('blocklyEditor', 'menuEditorPadding')};
    margin: ${({ theme, hidden }) => (hidden ? 0 : theme.blocklyEditor.toggleGroupMargin)};
    width: ${({ hidden }) => (hidden ? 0 : '104px')};
    transition: width 0.3s ease-in-out;
`;

let ToggleIconContainer = styled(View)`
    background-color: ${props =>
        props.selected
            ? fromTheme('colorScheme', 'background-dark')(props)
            : fromTheme('backgroundColorDarker')(props)};
    padding: ${fromTheme('blocklyEditor', 'menuEditorPadding')};
    width: ${fromTheme('blocklyEditor', 'toggleSize')};
    height: ${fromTheme('blocklyEditor', 'toggleSize')};
    align-items: center;
    justify-content: center;
    border-radius: ${fromTheme('menu', 'menuItem', 'borderRadius')};
`;
ToggleIconContainer = webOnlyStyles(ToggleIconContainer)`
    cursor: pointer;
    &:hover {
        background-color: ${fromTheme('colorScheme', 'background-dark')};
    }
`;

export function ToggleButtons(props) {
    const { options = [], onChange, hidden } = props || {};
    const [selected, setSelected] = useState();

    const onClick = useCallback(
        key => {
            if (selected === key) {
                setSelected(null);
                onChange?.(null);
            } else {
                setSelected(key);
                onChange?.(key);
            }
        },
        [selected, onChange]
    );
    return rc(
        ToggleGroup,
        { hidden },
        options.map(option =>
            rc(
                ToggleIconContainer,
                {
                    key: option.key,
                    'data-testid': `${option.description || option.key}${
                        selected && selected !== option.key ? '-disabled' : ''
                    }${selected === option.key ? '-selected' : ''}`,
                    title: option.description || option.key,
                    disabled: selected && selected !== option.key,
                    selected: selected === option.key,
                    onClick: () => onClick(option.key)
                },
                rc(Icon, { onClick: () => onClick(option.key) }, option.icon)
            )
        )
    );
}

export default ToggleButtons;
